<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <Vlog :type='type'></Vlog>        
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Vlog from '@/components/vlog'

export default {
  data () {
    return {
      type:'add',
      navBlock: '新聞  /  Vlog',
      navtitle: '新增Vlog'
    }
  },
  methods:{
  },
  components: {
    NavBar,
    Vlog
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/news/vlog/addVlog.vue